export default {
  regulatorySymbols: [],
  regulatorySymbol: undefined,
};
